module.exports = __webpack_public_path__ + "img/Luna-Collection.f395b356.png";